import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Skeleton from '@material-ui/lab/Skeleton';
import Slide from '@material-ui/core/Slide';
import FollowersComponent from './FollwerComponent';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FollowingDialog(props) {
  const [loadingList, setloadingList] = useState(true);
  const [followingList, setfollowingList] = useState([]);

  // console.log(followingList,'follow');

  useEffect(() => {
    // console.log("call", props.artistId, props.dialogState);

    if (props.artistId && props.dialogState) {
      getFollowing();
    }
  }, [props.artistId, props.dialogState]);

  const getFollowing = async () => {
    setloadingList(true);
    let dataRef;
    try {
      dataRef = await getDocs(
        collection(
          firebaseFireStore,
          'musicartSellers',
          props.artistId,
          'followingArtists',
        ),
      );

      if (dataRef.empty) {
        setfollowingList([]);
        setloadingList(false);
        return null;
      }

      let dataArr = [];

      if (dataRef.docs.length > 0) {
        await Promise.all(
          dataRef.docs.map(async ({ id }) => {
            //getting seller data
            let sellerRef = await getDoc(
              doc(firebaseFireStore, 'musicartArtists', id),
            );

            // console.log(sellerRef, 'sellerRef')
            if (sellerRef.exists) {
              dataArr.push({ ...sellerRef.data(), id: id });
            }
          }),
        );
      } else {
        setfollowingList([]);
        setloadingList(false);
      }

      setfollowingList([...dataArr]);
      setloadingList(false);
    } catch (err) {
      // console.log("err", err);
      setloadingList(false);
    }
  };

  const handleClose = () => {
    props.setdialogState(false);
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: 450,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 999 }}
      maxWidth="md"
      onClose={handleClose}
    >
      <div>
        <div
          className="dialog-titlebar dialog_borderBottom sticky bg-white top-0 left-0 z-10"
          style={{
            padding: '15px 20px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div className="dialog-title" style={{ fontSize: 20 }}>
            Following
          </div>
          <div style={{ marginLeft: 'auto', marginRight: 10 }}>
            <button
              className="text-black text-lg font-light rounded-full outline-none focus:outline-none border border-gray-300"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div>
          <DialogContent className="space-y-5">
            {!loadingList &&
              followingList.map((ele, index) => {
                return <FollowersComponent ele={ele} isForFollowing={true} />;
              })}
            {(() => {
              if (loadingList) {
                return (
                  <div
                    className="flex 	w-full my-6 mx-6 mt-10"
                    style={{ flexDirection: 'column' }}
                  >
                    <Skeleton animation="wave" height={20} width="60%" />
                    <Skeleton animation="wave" height={20} width="60%" />
                    <Skeleton animation="wave" height={20} width="60%" />
                  </div>
                );
              } else if (
                !loadingList &&
                (!followingList || followingList.length === 0)
              ) {
                return <p className="text-center">0 followers found</p>;
              }
            })()}
          </DialogContent>
        </div>
      </div>
    </Dialog>
  );
}
